import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/queryKeys';
import { api } from '../../services/api';

export const useQuerySecondLeagueNO = () => {
  return useQuery({
    queryKey: queryKeys.standingsByRegion('NO', '2'),
    queryFn: async () => {
      const response = await api.fetchStandings(`2-bundesliga-nord-ost`);
      return response.standings;
    },
    enabled: true,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}

export const useQuerySecondLeagueSW = () => {
  return useQuery({
    queryKey: queryKeys.standingsByRegion('SW', '2'),
    queryFn: async () => {
      const response = await api.fetchStandings(`2-bundesliga-sued-west`);
      return response.standings;
    },
    enabled: true,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}

export const useAllStandingsSecondLeague = () => {
  const noQuery = useQuerySecondLeagueNO();
  const swQuery = useQuerySecondLeagueSW();

  const isLoading = noQuery.isLoading || swQuery.isLoading;

  const error = noQuery.error || swQuery.error;

  const data = React.useMemo(() => {
    if (!noQuery.data || !swQuery.data) return [];
    return {
      NO: noQuery.data,
      SW: swQuery.data,
    };
  }, [noQuery.data, swQuery.data]);

  return {
    data,
    isLoading,
    error,
  };
}
export const useQueryFirstLeague = () => {
  return useQuery({
    queryKey: queryKeys.standingsByRegion('all', '1'),
    queryFn: async () => {
      const response = await api.fetchStandings(`1-bundesliga`);
      return response.standings;
    },
    enabled: true,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}

export const useStandingsFirstLeague = () => {
  const query = useQueryFirstLeague();
  const isLoading = query.isLoading;

  const error = query.error;

  const data = React.useMemo(() => {
    if (!query.data) return [];
    return {
      query: query.data
    };
  }, [query.data]);

  return {
    data,
    isLoading,
    error,
  };
}
